module.exports = __webpack_public_path__ + "img/edit-icon.f7f1821e.svg";